import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Zap } from 'lucide-react';
import toast from 'react-hot-toast';

const SuccessPage = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    toast.success('Welcome to Pro! 🎉',
      { duration: 5000 });

    // Countdown timer ✅
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/generator');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-950
                    flex items-center
                    justify-center px-4">
      <div className="text-center max-w-md">

        <CheckCircle className="w-20 h-20
                                text-green-400
                                mx-auto mb-6" />

        <h1 className="text-4xl font-bold
                       text-white mb-4">
          You're Pro! 🚀
        </h1>

        <p className="text-gray-400 mb-2">
          Welcome to ScaffoldBridge Pro.
          You now have unlimited generations,
          GitHub push, Docker and more!
        </p>

        {/* Countdown ✅ */}
        <p className="text-gray-600 text-sm mb-8">
          Redirecting to Generator
          in {countdown}s...
        </p>

        <div className="bg-gray-900 border
                        border-green-500/20
                        rounded-2xl p-6 mb-8
                        text-left">
          <p className="text-green-400
                        font-semibold mb-3">
            ✅ Pro Features Unlocked:
          </p>
          <ul className="space-y-2">
            {[
              'Unlimited generations',
              'GitHub push delivery',
              'Docker image generation',
              'CI/CD pipeline',
              'Priority support'
            ].map(f => (
              <li key={f}
                  className="text-gray-400
                             text-sm flex
                             items-center gap-2">
                <span className="text-green-400">
                  →
                </span>
                {f}
              </li>
            ))}
          </ul>
        </div>

        <button
          onClick={() => navigate('/generator')}
          className="flex items-center gap-2
                     bg-blue-600 hover:bg-blue-500
                     text-white font-bold
                     px-8 py-4 rounded-xl
                     transition-colors mx-auto">
          <Zap className="w-5 h-5" />
          Start Generating →
        </button>
      </div>
    </div>
  );
};

export default SuccessPage;